import { Injectable } from '@angular/core'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { User } from '../model/user'

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private http: HttpClient) { }

    userList(user: User) {
        let params = new HttpParams()
            .set('company', user.company!)

        if (user.userType) {
            params = params.set('userType', user.userType!)
        }
        return this.http.get(environment.apiBaseUrl + '/user-list', { params: params })
    }

    userSave(data: any) {
        return this.http.post(environment.apiBaseUrl + '/user-save', data)
    }

    getUser(user: User) {
        let params = new HttpParams()
            .set('username', user.username!)
            .set('application', environment.application)
        return this.http.get(environment.apiBaseUrl + '/user-get', { params: params })
    }

    userDelete(user: User) {
        let params = new HttpParams()
            .set('username', user.username!)
        return this.http.delete(environment.apiBaseUrl + '/user-delete', { params: params })
    }
}
